import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Button } from '@pwc/pwc-deals-ui';
import StatusPill from '../../common/components/Pills/StatusPill';
import locationService from '../../common/services/locationService';
import ProjectLoader from './ProjectLoader';
import './ProjectStatus.scss';
import { PROJECT_STATUS_CODES } from '../../common/constants/ProjectStatus';
import { isProjectCreationInProgress } from '../../common/helpers/projectStatusesUtils';
import ProjectStatePill from '../projectStatePill/ProjectStatePill';
import featureFlags from '../../common/helpers/featureFlags';

const { supportEmailNew } = featureFlags;

// eslint-disable-next-line consistent-return
const ProjectStatus = ({ project, isFavourite = false, isSearch = false }) => {
  const { t } = useTranslation();
  const handleEmail = () => {
    if (supportEmailNew) {
      locationService.redirect(`mailto:${supportEmailNew}`);
    }
  };

  if (project.status === PROJECT_STATUS_CODES.ON_HOLD) {
    return (
      <span className="project-status" data-testid="project-on-hold">
        <span className="project-status__icon">
          <Icon name="alert" width={24} className="fill icon-yellow" />
        </span>
        <span>
          Project initiation on hold as the team investigate an issue. The
          process will retry automatically.
        </span>
      </span>
    );
  }

  if (isProjectCreationInProgress(project.status)) {
    return (
      <span className="project-status align-items-center">
        <StatusPill
          title={t('projectInitiating')}
          status="provisioning"
          dataTestId="project-status-pill"
        />
        <ProjectLoader />
      </span>
    );
  }

  if (project.status === PROJECT_STATUS_CODES.FAILED) {
    return (
      <span
        className="project-status new-support-email"
        data-testid="project-failed"
      >
        <span className="project-status__icon">
          <Icon name="alert" width={24} className="fill icon-yellow" />
        </span>
        <span>
          An error occurred.
          {supportEmailNew ? (
            <span data-testid="support-info">
              {' '}
              If it continues, contact{' '}
              <Button className="button-link" onClick={handleEmail}>
                {supportEmailNew}
              </Button>
            </span>
          ) : null}
        </span>
      </span>
    );
  }
  if (
    [
      PROJECT_STATUS_CODES.INACTIVE,
      PROJECT_STATUS_CODES.INACTIVE_PENDING_IN_PROGRESS,
      PROJECT_STATUS_CODES.ARCHIVED,
      PROJECT_STATUS_CODES.ARCHIVING_IN_PROGRESS,
      PROJECT_STATUS_CODES.UNARCHIVING_IN_PROGRESS,
      PROJECT_STATUS_CODES.ARCHIVING_PENDING_IN_PROGRESS,
      PROJECT_STATUS_CODES.UNARCHIVING_PENDING_IN_PROGRESS,
      PROJECT_STATUS_CODES.ERROR_STATUS,
    ].includes(project.status)
  ) {
    return (
      <ProjectStatePill
        projectId={project.id}
        showWhenActive={false}
        isSmall
        isFavourite={isFavourite}
        isSearch={isSearch}
      />
    );
  }
  return null;
};

export default ProjectStatus;
